import { ApplicationRoutes } from "../../routes";
import { MenuItemData } from "../menu.types";
import {
	DashboardActiveIcon,
	DashboardIcon,
	PeopleIcon,
	ProductIcon,
	SettingsIcon,
	SolarMenuIcon,
	UtilitySetupMenuActiveIcon,
	UtilitySetupMenuIcon,
	PayAsYouGoMenuIcon
} from "../../assets/sidemenu-icons";
import { EnergyManagementDashboardIcon, FunnelIcon, RetentionIcon } from "../../assets/icons";

const base = `/${ApplicationRoutes.ADMIN_BASE}`;

/**
 * Side menu of the BPS admin portal. Items are static — this layout serves one
 * module, so there is no URL switch like the bills / utility menus have.
 *
 * Icons: Dashboard, Solar Provider, Utility Setup and Pay-As-You-Go use the BPS
 * assets. The rest still borrow from the existing sets — TODO: remap as they land.
 *
 * The active pill is solid brand orange, so an entry needs a white `isActiveIcon`
 * to stay legible on it. Dashboard and Utility Setup have one; the rest repeat
 * their dark icon and read poorly when selected.
 */
export const BPS_ADMIN_MENU: MenuItemData[] = [
	{
		text: "Dashboard",
		icon: <DashboardIcon />,
		isActiveIcon: <DashboardActiveIcon />,
		route: `${base}/${ApplicationRoutes.DASHBOARD}`,
		subMenuItems: [],
	},
	{
		text: "Product Analytics",
		icon: <ProductIcon />,
		isActiveIcon: <ProductIcon />,
		route: `${base}/${ApplicationRoutes.BPS_PRODUCT_ANALYTICS}`,
		subMenuItems: [
			{ text: "Funnels", route: `${base}/${ApplicationRoutes.BPS_PRODUCT_ANALYTICS}/${ApplicationRoutes.BPS_FUNNELS}`, icon: <FunnelIcon />, isActiveIcon: <FunnelIcon /> },
			// { text: "Retention", route: `${base}/${ApplicationRoutes.BPS_PRODUCT_ANALYTICS}/${ApplicationRoutes.BPS_RETENTION}`, icon: <RetentionIcon />, isActiveIcon: <RetentionIcon /> },
			// {
			// 	text: "Energy management", 
			// 	route: `${base}/${ApplicationRoutes.BPS_PRODUCT_ANALYTICS}/${ApplicationRoutes.BPS_ENERGY_MANAGEMENT}`,
			// 	icon: <EnergyManagementDashboardIcon />,
			// 	isActiveIcon: <EnergyManagementDashboardIcon />
			// }

		],
	},
	{
		text: "Solar Provider",
		icon: <SolarMenuIcon />,
		isActiveIcon: <SolarMenuIcon />,
		route: `${base}/${ApplicationRoutes.SOLAR_PROVIDER}`,
		subMenuItems: [],
	},
	{
		text: "Customer",
		icon: <PeopleIcon />,
		isActiveIcon: <PeopleIcon />,
		route: `${base}/${ApplicationRoutes.BPS_CUSTOMER}`,
		subMenuItems: [],
	},
	{
		text: "Search Parameter",
		icon: <PeopleIcon />,
		isActiveIcon: <PeopleIcon />,
		route: `${base}/${ApplicationRoutes.SEARCH_PARAMETER}`,
		subMenuItems: [],
	},
	{
		text: "Loan Summary Page",
		icon: <PeopleIcon />,
		isActiveIcon: <PeopleIcon />,
		route: `${base}/${ApplicationRoutes.LOAN_SUMMARY}`,
		subMenuItems: [],
	},
	{
		text: "Loan Product Page",
		icon: <PeopleIcon />,
		isActiveIcon: <PeopleIcon />,
		route: `${base}/${ApplicationRoutes.LOAN_PRODUCTS}`,
		subMenuItems: [],
	},
	{
		text: "Utility Setup",
		icon: <UtilitySetupMenuIcon />,
		isActiveIcon: <UtilitySetupMenuActiveIcon />,
		route: `${base}/${ApplicationRoutes.BPS_UTILITY_SETUP}`,
		subMenuItems: [],
	},
	{
		text: "Pay-As-You-Go",
		icon: <PayAsYouGoMenuIcon />,
		isActiveIcon: <PayAsYouGoMenuIcon />,
		// Expandable entry — it toggles the sub-items instead of navigating.
		route: undefined,
		subMenuItems: [
			{ text: "Option 1", route: `${base}/${ApplicationRoutes.BPS_PAYG_OPTION_1}` },
			{ text: "Option 2", route: `${base}/${ApplicationRoutes.BPS_PAYG_OPTION_2}` },
		],
	},
	{
		text: "Active Payment",
		icon: <PeopleIcon />,
		isActiveIcon: <PeopleIcon />,
		route: `${base}/${ApplicationRoutes.BPS_ACTIVE_PAYMENT}`,
		subMenuItems: [],
	},
	{
		text: "Settings",
		icon: <SettingsIcon />,
		isActiveIcon: <SettingsIcon />,
		route: `${base}/${ApplicationRoutes.SETTINGS}`,
		subMenuItems: [],
	},
];
